import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { UtilService } from '@service/util/util.service';
import { UrlService } from '@service/url/url.service';
import { RestService } from 'cargo-chief-commons';
import { SNACKBAR } from '@domain/constants/snackbar-setting';

@Component({
	selector: 'app-add-price-review-dialog',
	templateUrl: 'add-price-review-dialog.html',
})
export class AddPriceReviewDialogComponent implements OnInit {
	isRequestInProgress = false;
	priceReviewForm: UntypedFormGroup;

	constructor(
		public dialogRef: MatDialogRef<AddPriceReviewDialogComponent>,
		private urlService: UrlService,
		private restService: RestService,
		private utilService: UtilService,
		private _formBuilder: UntypedFormBuilder
	) {}

	closeDialog(): void {
		this.dialogRef.close();
	}

	ngOnInit() {
		this.priceReviewForm = this._formBuilder.group({
			lastBooked: [new Date(), Validators.required],
			allInPrice: ['', Validators.required],
		});
	}

	submitReview() {
		if (this.priceReviewForm.valid) {
			this.isRequestInProgress = true;
			const url = this.urlService.addPriceReview();
			const payload = Object.assign({}, this.priceReviewForm.value);
			this.restService.POST(url, payload).subscribe(
				(result) => {
					if (result != null) {
						this.utilService.showSnackbar(
							'Price review submitted successfully.',
							SNACKBAR.SUCCESS,
							SNACKBAR.ACTION
						);
					} else {
						this.utilService.showSnackbar(
							'Unable to submit price review now. Please try again later.',
							SNACKBAR.WARNING,
							SNACKBAR.ACTION
						);
					}
					this.isRequestInProgress = false;
					this.dialogRef.close(result);
				},
				(error) => {
					this.utilService.showSnackbar(
						`Unable to submit price review now. ${error.error}`,
						SNACKBAR.ERROR,
						SNACKBAR.ACTION
					);
					this.isRequestInProgress = false;
				}
			);
		}
	}
}
